import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import packageJson from '../../../package.json';

const Wrapper = styled(FullWidthPageContent)`
  padding: ${({ theme }) => theme.spacing * 4}px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.colors.white};
`;

const CopyRight = styled.div`
  margin: ${({ theme }) => theme.spacing}px;
`;

const Version = styled.p`
  font-size:0.7rem;
  font-weight: 600;
  background-color:${({ theme }) => theme.palette.colors.grey5};
  padding: ${({ theme }) => theme.spacing}px;
`;

const Links = styled.ul`
  font-size:0.875rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  li {
    white-space: nowrap;
    display: flex;
    align-items: center;
    &::after{
      height: 1em;
      content:"";
      border-right: 1px solid ${({ theme }) => theme.palette.colors.grey45};
    }
    &:last-child{
      &::after{
        border: none;
      }
    }

    a{
      padding: ${({ theme }) => theme.spacing}px ${({ theme }) => theme.spacing * 2}px;
      text-decoration: none;
      color: inherit;
    }
  }

`;

const PrivacyPolicyFooterWidget = ({ className, links }) => {
  const classes = ['PrivacyPolicyFooterWidget'];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(' ')}>
      <CopyRight>© Specsavers 2020</CopyRight>
      <Links>
        {links.map((l) => (<li key={l.url}><a target="_blank" rel="noopener noreferrer" href={l.url}>{l.label}</a></li>))}
      </Links>
      <Version>{packageJson.version}</Version>
    </Wrapper>
  );
};

PrivacyPolicyFooterWidget.displayName = 'PrivacyPolicyFooterWidget';

PrivacyPolicyFooterWidget.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  })),
};

PrivacyPolicyFooterWidget.defaultProps = {
  className: null,
  links: [],
};

export default PrivacyPolicyFooterWidget;
